module.exports = __webpack_public_path__ + "img/stop-line.6fa816c8.png";